import { GenericObject } from "utility/misc";

export default function redirectToAzureConnectPage(
  _orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/sources/azure/connect");
}
